export default __webpack_public_path__ + "static/media/Activity4.43fb4950.jpeg";